export default "__VITE_ASSET__Dzq3C2Fm__"